import React, { memo } from 'react';
import cx from 'clsx';

import { EmptyRecord } from '@/components';

import style from './index.module.css';

type EmptyStreamProps = {
  className?: string;
  address?: string;
  placeholder?: string;
};

export const EmptyStream = memo(
  ({
    className,
    placeholder = 'Nothing here yet? Find someone to follow or post your first words.',
  }: EmptyStreamProps) => {
    return (
      <div className={cx(style.emptyStream, className)}>
        <EmptyRecord content={placeholder} />
      </div>
    );
  },
);
